
import { defineComponent, PropType } from 'vue';
// import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import viewerInstance, { TList } from '../lib/viewer';

// interface IUrlList {
//   url: string;
//   [propName: string]: any;
// }

// type List = (string | IUrlList)[];

export default defineComponent({
  name: 'ImageViewer',
  props: {
    list: {
      type: Array as PropType<TList>,
      default: () => [],
    },
    /**
     * flex 居中
     */
    flexCenter: Boolean,
  },
  setup(props) {
    // const viewerRef = ref<HTMLDivElement>();
    // let $viewer: Viewer | null = null;

    const view = (index: number = 0) => {
      viewerInstance.update(props.list);
      const i = typeof index === 'number' ? index : 0;
      viewerInstance.view(i);
      // if (!$viewer) {
      //   $viewer = new Viewer(viewerRef.value!, {
      //     className: 'viewer-custom-style',
      //     zIndex: 99999,
      //     fullscreen: false,
      //   });
      // }
      // $viewer.view(index);
    };

    // onMounted(() => {
    //   nextTick(() => {

    //   });
    // });

    // watch(
    //   () => props.list,
    //   () => {
    //     if ($viewer) {
    //       nextTick(() => {
    //         $viewer?.update?.();
    //       });
    //     }
    //   },
    //   { deep: true },
    // );

    // onUnmounted(() => {
    //   nextTick(() => {
    //     $viewer?.destroy?.();
    //     $viewer = null;
    //   });
    // });

    return {
      // viewerRef,
      view,
    };
  },
});
